import React from 'react';
import './NiveauRecruteur.css';

const NiveauRecruteur = ({ niveau, stats }) => {
  if (!niveau || !niveau.label) {
    return <div className="niveau-container">Niveau non défini.</div>;
  }

  return (
    <div className="niveau-container">
      <h3 className="niveau-title">Niveau du Recruteur</h3>

      <div className="niveau-badge" style={{ backgroundColor: niveau.color }}>
        {niveau.label}
      </div>

      <ul className="niveau-stats">
        <li>Total de talents ajoutés : <strong>{stats?.total ?? 0}</strong></li>
        <li>Talents qualifiés : <strong>{stats?.qualifies ?? 0}</strong></li>
        <li>Talents proposés : <strong>{stats?.proposes ?? 0}</strong></li>
        <li>Talents recrutés : <strong>{stats?.recruited ?? 0}</strong></li>
        {stats?.primeTotale && (
        <li>
          Prime estimée :
          <ul>
            {Object.entries(stats.primeTotale).map(([devise, montant]) => (
              <li key={devise}>
                <strong>{montant}</strong> {devise}
              </li>
            ))}
          </ul>
        </li>
      )}
      </ul>
    </div>
  );
};

export default NiveauRecruteur;
